import React, { Component } from "react";
import Storage from "../services/storage.service";
import { generalEvent } from "../services/tracking.service";

export default class ModalLayout extends Component {
  close = () => {
    if (this.props.close) {
      this.props.close();
    }
  };

  componentDidMount() {
    Storage.set("modal_open", this.props.type ? this.props.type : "basic");
  }

  componentWillUnmount() {
    Storage.clear("modal_open");
  }

  render() {
    let title = "";
    let size = this.props.size ? this.props.size : "";
    let type = this.props.type ? this.props.type : "basic";
    let type2 = this.props.type2 ? this.props.type2 : "";

    if (this.props.title) {
      title = (
        <div className="vmo-modal-header">
          {this.props.close ? (
            <div className="vmo-modal-close" onClick={() => {
              this.close();
              let eventObj = {
                eventCustomName : "click_cta",
                extra_obj : {
                    cta_name: 'modal close',
                    cta_type: 'button',
                    cta_position: 'body'
                }
            }
            generalEvent(eventObj);
            }} />
          ) : (
            ""
          )}
          <h2 className="vmo-modal-title">{this.props.title}</h2>
        </div>
      );
    } else {
      if (this.props.icon) {
        title = (
          <div className="vmo-modal-header">
            {this.props.close ? (
              <div className="vmo-modal-close" onClick={() => {
                this.close();
                let eventObj = {
                  eventCustomName : "click_cta",
                  extra_obj : {
                      cta_name: 'modal close',
                      cta_type: 'button',
                      cta_position: 'bottom'
                  }
              }
              generalEvent(eventObj);
              }} />
            ) : (
              ""
            )}
          </div>
        );
      }
    }

    let content = "";

    if (size === "small") {
      content = (
        <>
          <div className="vmo-modal-inner">
            {this.props.close ? (
              <div className="vmo-modal-close" onClick={() => {
                this.close();
                let eventObj = {
                  eventCustomName : "click_cta",
                  extra_obj : {
                      cta_name: 'modal close',
                      cta_type: 'button',
                      cta_position: 'bottom'
                  }
              }
              generalEvent(eventObj);
              }
            } 
              />
            ) : (
              ""
            )}
            <div className="vmo-modal-message vmo-with-icon">
              {this.props.children}
            </div>
          </div>
        </>
      );
    } else {
      content = (
        <>
          {type2 === "title-out" ? title : ""}
          <div className="vmo-modal-inner">
          {this.props.image ?? ''}
            {type2 !== "title-out" ? title : ""}
            <div className="vmo-modal-content">
              <div className="vmo-modal-scroll">
                <div className="vmo-modal-scroll-inner">
                  {this.props.children}
                </div>
              </div>
            </div>
          </div>
        </>
      );
    }

    let size_classes = "";
    if (size) {
      let sizes = size.split(" ");
      size_classes = [];
      for (let size of sizes) {
        size_classes.push(" vmo-modal-" + size);
      }
      size_classes = size_classes.join("");
    }

    let extras = this.props.extras || "";

    return (
      <div
        className={
          "vmo-modal " +
          extras +
          size_classes +
          " vmo-modal-" +
          type +
          " vmo-modal-" +
          type2
        }
      >
        <div className="vmo-modal-backdrop" onClick={() => {
          this.close();
          let eventObj = {
            eventCustomName : "click_cta",
            extra_obj : {
                cta_name: 'modal close',
                cta_type: 'button',
                cta_position: 'bottom'
            }
        }
        generalEvent(eventObj);
        }} />
        <div className="vmo-modal-centered">{content}</div>
      </div>
    );
  }
}